import React, {useContext} from 'react';
import {AuthContext} from 'contexts/AuthContext';
import {membershipGenerator} from 'contexts/MembershipContext';
import {Redirect} from 'react-router-dom';
import {
  PATH_DASHBOARD,
  PATH_AFTER_LOGIN,
  COMPANY_STATUSES,
  PATH_ISOSURVEY,
  PATH_PUBLIC_ISO_SURVEY,
} from 'configs';
import useQuery from 'hooks/useQuery';
import {SUBSCRIPTION_TYPE_LEVEL} from 'configs/membership';

function byDefault(Component) {
  return function (props) {
    const {redirect = true} = props;
    const {isAuth, account, handleLogin, isDCAccount, isMainAccount} =
      useContext(AuthContext);
    const {company} = account || {};
    const {company_status} = company || {};
    const isCompanySuspended = company_status === COMPANY_STATUSES.suspended;
    const {query} = useQuery();

    const redirectToIsoSurvey = (account) => {
      const {isTrial, isLegacyUser, subscriptionLevel} =
        membershipGenerator(account);
      const isEnterprise =
        subscriptionLevel === SUBSCRIPTION_TYPE_LEVEL.enterprise;
      const isFree = subscriptionLevel === SUBSCRIPTION_TYPE_LEVEL.free;

      if (isFree || (!isLegacyUser && !isTrial) || isEnterprise) {
        return PATH_ISOSURVEY;
      } else {
        return PATH_AFTER_LOGIN;
      }
    };

    if (isAuth && isDCAccount && redirect)
      return <Redirect to={PATH_DASHBOARD} push={false} />;

    if (isAuth && isMainAccount && redirect) {
      if (isCompanySuspended) {
        return <Redirect to={PATH_DASHBOARD} push={false} />;
      } else {
        return (
          <Redirect
            to={
              query.from === PATH_PUBLIC_ISO_SURVEY
                ? redirectToIsoSurvey(account)
                : PATH_AFTER_LOGIN
            }
            push={false}
          />
        );
      }
    }

    const states = {
      title: 'Log in',
      text: 'Please log in to your account',
      onSubmit: handleLogin,
    };

    return <Component {...states} {...props} />;
  };
}

export default byDefault;
